function init( selector = '.btn-fb' )
{
  const sharedFb = document.querySelector( selector )

  sharedFb.addEventListener( 'click', e => {
    e.preventDefault()

    const url = document.querySelector( 'link[rel="canonical"]' ).href || ''

    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + escape( url ),
      'shared_modal'
    )
  })

}

export default {
  init
}
